import type {
  NoDataResponse,
  PaginationRequestParams,
  PathVariableRequestParams,
} from '@/types/api';
import type {
  GetPartnerNoticeResponse,
  GetPartnerNoticesMainResponse,
  GetProductOrderResponse,
  GetProductOrdersResponse,
  GetProductResponse,
  GetProductsResponse,
  OrderProductParams,
  OrderProductResponse,
} from '@/types/partner';
import axios from '@/utils/axios';

export const getProducts = ({
  page,
  size,
}: PaginationRequestParams): Promise<GetProductsResponse> => {
  return axios
    .get('/partner/v1/products', {
      params: {
        page,
        size,
      },
    })
    .then((res) => res.data);
};

export const getProduct = ({
  id,
}: PathVariableRequestParams): Promise<GetProductResponse> => {
  return axios.get(`/partner/v1/products/${id}`).then((res) => res.data);
};

export const orderProduct = (
  data: OrderProductParams
): Promise<OrderProductResponse> => {
  return axios.post(`/partner/v1/orders`, data).then((res) => res.data);
};

export const getProductOrders = ({
  page,
  size,
}: PaginationRequestParams): Promise<GetProductOrdersResponse> => {
  return axios
    .get(`/partner/v1/orders`, {
      params: {
        page,
        size,
      },
    })
    .then((res) => res.data);
};

export const getProductOrder = ({
  id,
}: PathVariableRequestParams): Promise<GetProductOrderResponse> => {
  return axios.get(`/partner/v1/orders/${id}`).then((res) => res.data);
};

export const cancelProductOrder = ({
  id,
}: PathVariableRequestParams): Promise<NoDataResponse> => {
  return axios.delete(`/partner/v1/orders/${id}`).then((res) => res.data);
};

/** Notice */
export const getPartnerNoticesMain = ({
  page,
  size,
}: PaginationRequestParams): Promise<GetPartnerNoticesMainResponse> => {
  return axios
    .get('/partner/v1/notices/main', {
      params: {
        page,
        size,
      },
    })
    .then((res) => res.data);
};

export const getPartnerNotice = ({
  id,
}: PathVariableRequestParams): Promise<GetPartnerNoticeResponse> => {
  return axios.get(`/partner/v1/notices/${id}`).then((res) => res.data);
};
